import sectionImage from "../../../assets/homePageV2/landingPage.png";
import { conhecaOPastejoContent as c } from "./content";
import { ReactComponent as BackIcon } from "../../../assets/svg/icons/back.svg";

export function LandingPage() {
  return (
    <section
      className="home-page-v2__section home-page-v2__section--hero"
      style={{
        backgroundImage: `url(${sectionImage})`,
        backgroundPosition: "top"
      }}
    >
      <div className="home-page-v2__hero__subBanner"/>
      <div className="home-page-v2__section-inner">
        <div className="home-page-v2__hero">
          <span className="home-page-v2__hero-lead">{c.titlePrefix}</span>
          <br />
          <strong className="home-page-v2__brand">{c.titleBrand}</strong>
        </div>
        <div className="home-page-v2__tag-container">
          <div className="home-page-v2__tagline">
            <div>
              <BackIcon width={32} height={32} className="icon" />
            </div>
            <p>{c.subtitle}</p>
          </div>
        </div>
      </div>
      <div className="home-page-v2__cta-banner">
        <p className="home-page-v2__cta-banner--content">
          <strong className="home-page-v2__cta-strip home-page-v2__cta-strip--lead">{c.ctaBannerBold}</strong>{" "}
          <span className="home-page-v2__cta-strip home-page-v2__cta-strip--tail">{c.ctaBannerRest}</span>
        </p>
      </div>
    </section>
  );
}
